import { Component, OnInit } from '@angular/core';
import { BaseService } from '../../services/base.service'
import { AlertService } from '../../services/alert.service'
import { AuthService } from '../auth.service';
import { ILoginViewModel } from '../../models/ILoginViewModel'
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { NgForm } from '@angular/forms';

@Component({
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

  private errors: string;
  public isRequesting : boolean = false;
  public loginModel: ILoginViewModel = {userName : '', password : ''};
  private returnUrl: string;

  constructor(private router: Router, private route: ActivatedRoute,
              private authService: AuthService, private alertService: AlertService) {
  }

  ngOnInit() {
    // this.router.url
    //this.authService.logout();
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  login(form: NgForm) {
    if (form.valid) {
      this.isRequesting = true;
      this.authService.login(form.value, this.returnUrl);
      this.isRequesting = false;
      form.reset();
    }
    
  }

  register() {
    this.router.navigate(["/register"]);
  }


}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/account/login/login.component.ts